// Geçmiş Rapor Aktarımı — IMPORT_COPY sabiti (Task 12).
// report-import-ui.ts 600 satır sınırını aştığı için ayrıldı (task-12-brief.md talimatı);
// tüm anahtarlar report-import-ui.ts'ten re-export edilir, tüketiciler tek yerden alır.
// Katman sırası: body < Eng review < Tasarım review < Regresyon analizi (sonraki katman
// öncekini override eder) — task-12-brief.md.

export const IMPORT_COPY = {
  // --- Sayfa / sekmeler ---
  pageTitle: "Geçmiş Rapor Aktarımı",
  pageEyebrow: "Projeler",
  tabNew: "Yeni parti",
  tabJobs: "İşler",
  tabDone: "Tamamlanan",

  // --- Dropzone ---
  dropzone: "PDF ya da Word (.docx) dosyalarını buraya sürükleyin ya da seçin",
  dropzoneHint: "PDF, DOCX · en fazla 50 MB · aynı raporun PDF ve Word'ü aynı satırda gruplanır",
  rejectIndd: "InDesign dosyası desteklenmiyor; PDF ya da Word (.docx) export yükleyin",
  rejectDoc: ".docx olarak kaydedip yükleyin",
  rejectSize: "Dosya 50 MB sınırını aşıyor",
  // 8A — durum tablosu
  dropzoneFirstUse: "Her rapor ayrı bir proje olur. Yükleyin, eşleştirin, partiyi işleyin.",
  rowUploading: "Yükleniyor %{n}",
  rowSuggesting: "Öneri hesaplanıyor…",
  uploadFailed: "{file} yüklenemedi — Yeniden dene",
  // 16A — FileDropzone / fill modal
  chooseFile: "Dosya seç",
  pairNote: "Word kullanılacak; açılamazsa PDF",
  fileUploaded: "yüklendi",
  fileRemove: "Kaldır",
  // 7A — 100'lük parti sınırı
  rejectBatchLimit:
    "Bir partide en fazla 100 rapor işlenebilir. İlk 100 dosya eklendi, {n} dosya eklenmedi.",

  // --- Satır tablosu kolonları ---
  colFile: "Dosya",
  colClient: "Müşteri",
  colYear: "Yıl",
  colPeriod: "Dönem",
  colType: "Tür",
  colFramework: "Çerçeve",
  colPackage: "Paket",
  colStatus: "Durum",
  // 9A
  colFinished: "Bitiş",
  colBatch: "Parti",
  colActions: "Aksiyonlar",
  colResult: "Sonuç",
  rowActionsHeader: "Satır aksiyonları",
  searchPlaceholder: "Müşteri ara",
  // Filtre dropdown placeholder'ları (9A — seçenekler `{etiket}: {değer}` öneklidir)
  filterAllSuffix: "(tümü)",
  // Genel etiketler (IMPORT_COPY dışına sızmasın diye burada — fix round 1)
  cancelGeneric: "Vazgeç",
  retryGeneric: "Yeniden dene",
  loadingGeneric: "Yükleniyor…",
  closeGeneric: "Kapat",
  expand: "genişlet",
  emptyDoneHint: "Bir parti tamamlandığında burada listelenir.",
  emptyJobsHint: "Yeni parti sekmesinden rapor yükleyin; işler burada canlı ilerler.",
  existsActiveImport: "İşler sekmesinde sürüyor",
  unmappedEmpty: "Eşleştirilemeyen blok yok.",
  unmappedToc: "Eşleştirilemeyen bloklar",
  settingsLink: "Ayarlar'da düzeltin",

  // --- 4A — ProjectsList / ArchiveList (R13) ---
  importedPill: "aktarıldı",
  sourceFilterLabel: "Kaynak (tümü)",
  sourceFilterImport: "Aktarım",
  sourceFilterManual: "Elle",

  // --- Satır durumu (rowReadiness) ---
  readyLabel: "hazır",
  missingLabel: "eksik",
  existsLabel: "zaten var",
  suggestionMark: "✦ Kapaktan öneri",
  existsInFramework: "zaten var (bu çerçevede)",

  // --- Satır içi "+ Yeni müşteri" (UX paketi, 2026-10-01) ---
  newClientOption: "+ Yeni müşteri: {name}",
  newClientOptionBlank: "+ Yeni müşteri…",
  newClientNameLabel: "Yeni müşteri adı",
  newClientSimilar: "Benzer kayıtlar:",
  newClientCreate: "Oluştur",
  newClientError: "Müşteri oluşturulamadı",
  newClientTooShort: "Şirket adı en az 2 karakter",
  newClientExists: "Bu adla kayıt zaten var — seçin",
  // 2026-10-01 — satır içi yeni müşteride sektör (paket önerisinin öncelikli kaynağı)
  newClientSectorLabel: "Sektör (sektör paketi önerisi için)",
  newClientSectorBlank: "— sektör seçilmedi —",
  clientsUnavailable: "Müşteri listesi alınamadı — mevcut kayıtları görmeden yeni kayıt açmayın",

  // --- Satır kaldırma (6A) ---
  removeRow: "Satırı kaldır: {fileName}",
  rowRemoved: "Satır kaldırıldı",
  undoRemove: "Geri al",
  skippedRowsNote: "{n} satır işlenmeyecek (eksik ya da zaten var).",
  openExistingProject: "Mevcut projeyi aç",

  // --- Taslak (7A) ---
  draftRestored: "Yarım kalmış parti bulundu ({n} satır).",
  draftContinue: "Devam et",
  draftDiscard: "Yeni başla",

  // --- Partiyi işle / tahmin ---
  processBatch: "Partiyi işle",
  processBatchCount: "Partiyi işle ({n})",
  estimateLine: "Tahmini {minutes} dk · ~{usd} USD",
  estimateUncalibrated: "(ilk partilerle kalibre edilir)",
  estimatePending: "Tahmin hesaplanıyor…",
  estimateUnavailable: "Tahmin şu an hesaplanamadı — işlemeyi engellemez",
  batchQueued: "{n} rapor kuyruğa alındı. İlerlemeyi İşler sekmesinden izleyin.",
  queueSummary: "Kuyruk: {running} işleniyor · {waiting} bekliyor",

  // --- İşler listesi sonucu (eski tek-satır + 5A iki/üç-satır) ---
  resultPrimary: "{answered}/{total} soru aktarıldı",
  resultExceptions: "{low} kontrol gerekli · {rejected} aktarılmadı · {failed} bölüm işlenemedi",
  // P6 — istisna satırının sonuna eklenir (yalnız > 0 iken).
  resultPartial: "{partial} kısmi",
  resultDetails: "{sections} bölüm",
  resultEmpty: "Hiçbir soru aktarılamadı — raporu ve çerçeveyi kontrol edin",
  // M9 (parti 06cc §9 UI) — İKİ AYRI KAVRAM, İKİ AYRI SÖZCÜK. `unmappedCount` RAPORUN
  // hiçbir soruya eşlenmeyen BLOKLARIdır (`report_imports.unmapped_content`);
  // `resultUnmapped` ise ÇERÇEVENİN hiç sayfa almayan BÖLÜMLERİdir
  // (`stats.unmappedSections`). İkisi de "eşlenmemiş (n)" dediği için aynı satırda
  // hangi sayının neyi saydığı anlaşılmıyordu.
  unmappedCount: "eşlenmemiş blok ({n})",
  // 5A — mono detay satırında kısa form ("n bölüm · eşlenmemiş bölüm (n) · …").
  resultUnmapped: "eşlenmemiş bölüm ({n})",
  listRefreshFailed: "Liste yenilenemedi — son bilinen durum gösteriliyor",
  provenanceUnavailable: "Aktarım bilgisi şu an yüklenemedi — yenileyin",
  // 8A — `provenanceUnavailable` satırındaki tekrar-dene eylemi (null ≠ hata).
  retryLoad: "Tekrar dene",
  authFailedRow: "Sağlayıcı anahtarı geçersiz — Ayarlar'da düzeltin",
  fallbackNote: "Word açılamadı, PDF kullanıldı",

  // --- Aşama metinleri (5A, durum hücresi) ---
  stageQueued: "Sırada",
  stageReading: "Rapor okunuyor",
  stageMapping: "Bölümler eşleştiriliyor",
  stageExtracting: "{done}/{total} bölüm işleniyor",
  stageExtractingNoCount: "Bölümler işleniyor",
  stageWriting: "Kaydediliyor",
  stageDone: "Tamam",
  liveOn: "Canlı",
  liveOff: "5 sn'de bir yenileniyor",

  // --- Aksiyonlar ---
  actionCancel: "İptal",
  actionRetry: "Yeniden dene",
  actionOpenProject: "Projeyi aç",
  actionOpenReport: "Raporu aç",
  actionArchive: "Geri çek",
  retryDisabledAuth: "Sağlayıcı anahtarı geçersiz — Ayarlar'dan düzeltin",

  // --- Boş durumlar ---
  emptyJobs: "Henüz iş yok",
  emptyDone: "Tamamlanan aktarım yok",

  // --- Rapordan doldur (fill modal) ---
  fillFromReport: "Rapordan doldur",
  // D12 (Regresyon analizi) — "Rapordan doldur" düğme metniyle çakışmasın.
  fillModalTitle: "Rapordan doldur — {client} · {period}",
  fillModalBody: "Yalnız boş sorular doldurulur; mevcut yanıtlar değişmez.",
  fillStart: "Aktarımı başlat",

  // --- ProjectDetail bandı ---
  // run3 inceleme (Minor 9) — pay ARTIK düşük güvenlileri İÇERİYOR (K1). Eski metin
  // "{answered}/{total} · {low} düşük" toplam gibi okunuyordu; "{low}'u" eki alt küme
  // olduğunu söylüyor. `bandImportedFragment` ("raporundan aktarıldı") korunur.
  // S6 (parti e290) — İYELİK EKİ SABİT DEĞİL: 3 → "3'ü", 7 → "7'si", 10 → "10'u".
  // Ek `possessiveSuffixTr` ile üretilir ve `{lowSuffix}` olarak geçirilir; dört
  // raporun üçünde "3'u"/"7'u" yazıyordu.
  bandImported:
    "📄 {file} raporundan aktarıldı · {answered}/{total} soru ({low}{lowSuffix} düşük güven) · {rejected} reddedilen",
  bandOpenReport: "raporu aç",
  archivedBand: "Bu projenin aktarımı geri çekildi ({date}).",
  // Fix round 1 (T14 review) — ImportSummarySection'daki inline literal'lar yerine.
  importCountSuffix: "{n} aktarım",
  unmappedShow: "göster",

  // --- FormFill çipleri (17A) ---
  chipAll: "Tümü",
  chipLow: "Düşük güven ({n})",
  chipRejected: "Reddedilen ({n})",
  chipEmpty: "Cevaplanmamış ({n})",
  // P6 (inceleme C3) — kısmi kabul edilen yanıtlar KENDİ çipinde; "Düşük güven" altında
  // sayılmaz (0,95 güvenli bir yanıta "düşük güven" demek yanlıştı). Çip yalnız n > 0
  // iken render edilir — kısmi olmayan projelerde çip listesi birebir eskisi gibi kalır.
  chipPartial: "Kısmi ({n})",
  chipsLegend: "Aktarım filtresi",
  filterHeader: "{label} — {n} soru, {s} bölümde",
  filterEmpty: "Bu filtreye uyan soru kalmadı.",
  // 2A — `filterHeader`'daki `{label}`: çip adının sayaçsız hali.
  chipLowLabel: "Düşük güven",
  chipRejectedLabel: "Reddedilen",
  chipEmptyLabel: "Cevaplanmamış",
  chipPartialLabel: "Kısmi",
  clearFilter: "Filtreyi temizle",

  // --- Köken rozeti / satırı ---
  badgePage: "s.{page}",
  badgeLocator: "{locator}",
  badgeAria: "Kaynak: sayfa {page}",
  badgeAriaOpen: "Kaynak: sayfa {page} — raporu aç",
  // DOCX'te sayfa yok, kısa locator var (`§3.1 · p.4`) — "sayfa §3.1" demek yanlış olurdu.
  badgeAriaLocator: "Kaynak: {locator}",
  badgeAriaLocatorOpen: "Kaynak: {locator} — raporu aç",
  // 13A — rozetin `title`'ı (görsel tooltip; ekran okuyucu `badgeAria`'yı duyar).
  badgeTitle: "Rapordan aktarıldı · {ref}",
  // 13A override'ları — tek fiil dili
  lowConfidenceLine: "Kontrol gerekli · {ref}",
  // run2-2 (a) — köken satırında AYRINTI varsa sebebi de söylenir: kullanıcı "Kontrol
  // gerekli" yazısının NEDEN'ini okur ("ölçek ipucu var (bin tl), sütun birimi yok …").
  lowConfidenceLineWithDetail: "Kontrol gerekli · {ref} — {detail}",
  rejectedLabel: "Aktarılmadı · kaynak doğrulanamadı",
  // İNCELEME (Important) — REDDİN SEBEBİ KÖKENDEN GELİYORSA onu yaz: mükerrer metin
  // reddinde ("aynı metin başka soruya yazıldı (<kod>)") metin raporda BİREBİR var,
  // sabit "kaynak doğrulanamadı" yanlış bilgi veriyordu.
  rejectedLabelWithDetail: "Aktarılmadı · {detail}",
  rejectedReasonGrounding: "metin raporda bulunamadı",
  rejectedReasonSchema: "değer soru tipine uymadı",
  seeProposal: "öneriyi gör",
  useProposal: "bu değeri kullan",
  // P6 — satır bazlı kısmi kabul (yanıt yazıldı ama bazı satırlar doğrulanamadı).
  partialLine: "{accepted}/{total} satır aktarıldı · {ref}",
  // F7 (final inceleme) — rozet aynı kartta `s.136`'yı zaten gösteriyorsa satırda
  // tekrar edilmez; ref'siz biçim yalnız rozet çizilmediğinde kullanılmaz (aksine:
  // rozet VARSA bu kullanılır, yoksa `partialLine` ref'li kalır).
  partialLineNoRef: "{accepted}/{total} satır aktarıldı",
  seePartialRows: "aktarılmayan satırları gör",
  partialTitle: "Aktarılmayan satırlar",
  partialSummary: "{accepted}/{total} satır aktarıldı; aşağıdakiler kaynakta doğrulanamadı.",
  partialRowsTruncated: "+{n} satır daha (listede gösterilmiyor)",
  // P8(c) — değer sorunun karakter sınırına indirildi (köken `method: ai-import-trim`).
  trimmedSuffix: "kısaltıldı",
  // P15/1b — kaynak "Bin TL" / "Milyon TL" diyordu; yazılan değer ölçeklendi
  // (köken `method: ai-import-scaled`). Kullanıcı büyüklük değişimini GÖRMELİ.
  // İnceleme (karar 2): çarpan ARTIK köken satırından gelir — sabit "×1.000" metni
  // ×1.000.000 vakasında (Ozak kira gelirleri) yanlış çarpan gösteriyordu.
  scaledSuffix: "×{factor} ölçeklendi",
  // G2 (parti e290 §6.2) — ölçek AİLESİ dönüşümünde kaynak hedeften büyük ölçekliyse
  // oran 1'den küçüktür (kaynak Bin TL, sütun Milyon TL → ÷1.000). Çarpan yerine
  // BÖLEN yazılır; "×0,001 ölçeklendi" okunmaz bir ifade.
  scaledSuffixDown: "÷{factor} ölçeklendi",
  // P15/6 — paket müşteri sektörüne göre değil RAPORA göre önerildi (Ozak: müşteri
  // kaydı "İnşaat", kapak "Gayrimenkul Yatırım Ortaklığı").
  sectorMismatchNote:
    "Müşteri sektörü ({client}) ile rapor ({cover}) uyuşmuyor — paket rapora göre önerildi",
  // 13A popover kabuğu (RejectedProposalPopover) — başlık + kapat.
  proposalTitle: "Ne önerilmişti?",
  proposalClose: "Kapat",
  // G8: collapsed önceki-yıl copy'si yalnız period-ui.ts priorYearHintCopy().collapsedLabel'da
  // tutulur — burada AYRI bir anahtar YOK (fix round 1: priorYearCollapsed silindi, kullanılmıyordu
  // ve farklı metin taşıyordu — iki kaynak çatallanırdı).
  // 10A override'ı
  editedLabel: "aktarımdan sonra düzenlendi",
  reviewBand: "📄 Rapordan aktarıldı · {ref} · yeniden yazılmadı",
  reviewBandEdited: "📄 Rapordan aktarıldı · {ref} · sonradan düzenlendi",
  // 11A
  proposalAccepted: "Öneri elle kabul edildi · {ref}",

  // --- Eşleştirilemeyen içerik (RAPOR tarafı — M9: "blok", çerçeve bölümü DEĞİL) ---
  unmappedBandTitle: "Eşlenmemiş blok ({n})",
  // M9/Minor 8 — çekmecede TEK sözcük: "blok" (çerçeve bölümüyle karışmasın).
  unmappedTitle: "Eşleştirilemeyen blok ({n})",
  // 18A override'ı
  unmappedBandHint: "Sorularla eşleştirilemeyen rapor blokları",
  openInReport: "Raporda aç (s.{page})",
  copy: "Kopyala",
  copied: "Kopyalandı",

  // --- 12A — ConfirmDialog metinleri (geri çek / iptal) ---
  archiveTitle: "Aktarımı geri çek",
  archiveConfirm:
    "{client} · {period} · {framework} aktarımı geri çekilecek. Proje silinmez; proje listelerinden ve önceki yıl önerilerinden kalkar. Aynı yıl yeniden aktarılabilir.",
  archiveAction: "Geri çek",
  cancelTitle: "Aktarımı iptal et",
  cancelConfirm:
    "{client} · {period} işlemi iptal edilsin mi? Şimdiye kadar çıkarılan veriler atılır, proje oluşturulmaz.",
  cancelKeep: "İşleme devam et",
  cancelAction: "İptal et",
  cancelRaced: "Aktarım zaten tamamlandı.",
} as const;

export type ImportCopyKey = keyof typeof IMPORT_COPY;
